module.exports = __webpack_public_path__ + "img/AGRALE.55b6b801.svg";